
export class WebSocketService {
//   private socket: WebSocket | null = null;
//   private eventHandlers: Map<string, Set<WebSocketEventHandler>> = new Map();
//   private readonly RECONNECT_INTERVAL_MS = 5000;
   static eventHandlers = new Map();
    static socket = null;
     static RECONNECT_INTERVAL_MS = 5000;

  static addEventListener(
    eventType,
    handler
  ) {
    console.log("hej");
    console.log(handler);
    if (!this.eventHandlers.get(eventType)) {
      this.eventHandlers.set(eventType, new Set());
    }
    this.eventHandlers.get(eventType)?.add(handler);
  }

  static removeEventListener(
    eventType,
    handler
  ) {
    this.eventHandlers.get(eventType)?.delete(handler);
  }

  static connect() {
    if (this.socket) {
      return;
    }
    console.log("connecting...");
    this.socket = this.createWebSocket();
    console.log(this.socket);
    this.socket.addEventListener("message", (e) => this.handleMessage(e));
    this.socket.addEventListener("error", (e) => this.handleError(e));
    this.socket.addEventListener("close", () => this.handleClose());
  }

  static disconnect() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }

  static createWebSocket() {
      let url = process.env.VUE_APP_ROOT_WEBSOCKET;
    // if (WebDavSettings.WebSocketPath) {
    //   url = WebDavSettings.WebSocketPath;
    // } else {
    //   const host = WebDavSettings.WebsiteRootUrl
    //     ? new URL(WebDavSettings.WebsiteRootUrl).host
    //     : window.location.host;
    //   url =
    //     window.location.protocol === "https:"
    //       ? "wss://" + host
    //       : "ws://" + host;
    // }
    console.log(`Creating WebSocket connection to ${url}`);
    return new WebSocket(`${url}`);
  }

  static async handleMessage(event) {
    console.log("got message")
    try {
      const data = JSON.parse(event.data);
      const handlers = this.eventHandlers.get(data.EventType);

      if (handlers) {
        await Promise.all([...handlers].map((handler) => handler(data)));
      }
    } catch (error) {
      console.error("Error handling WebSocket message:", error);
    }
  }

  static handleError(error) {
    console.error("WebSocket error:", error.message);
    this.disconnect();
    this.reconnect();
  }

  static handleClose() {
    this.socket = null;
    this.reconnect();
  }

  static reconnect() {
    setTimeout(() => this.connect(), this.RECONNECT_INTERVAL_MS);
  }
}

export const webSocketService = new WebSocketService();
